import React, { Component } from "react";
import Slider from "react-slick";
import FadeIn from "react-lazyload-fadein";
import { Link } from 'react-router-dom';
import { createPortal } from 'react-dom';

export default class Gallery extends Component {
	
	constructor(props) {
    	super(props);
    	this.state = {
			index : 0,
			color: 'white'
		}
		this.handleGoTo 	= this.handleGoTo.bind(this);
    }
    	
	componentDidMount() {
		setTimeout(() => {
			if (window.document.getElementsByClassName('slick-prev').length > 0) {
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-prev')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-prev-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseover', function(){
					document.documentElement.classList.add('state-next-hover');
				});
				window.document.getElementsByClassName('slick-next')[0].addEventListener('mouseout', function(){
					document.documentElement.classList.remove('state-next-hover');
				});
			}
		}, 500);
	}
    
    handleGoTo(_evt) {
	    _evt.preventDefault();  
	    this.slider.slickGoTo(_evt.currentTarget.getAttribute('data-key'), false);
	    setTimeout(() => {
			this.setState({ open : true, gOpen: true });
		}, 10);
    }
    
    
  			
	render() {
		
		let loaded = this.props.loaded;
		let gallery = this.props.gallery;
		
		if (gallery) {
			
			let settings = {
				dots: 			true,
				arrows: 		true,
				infinite: 		true,
				speed: 			0,
				slidesToScroll: 1,
				centerMode: 	false,
				variableWidth: 	false,
				beforeChange: 	(current, next) => this.setState({ index:next, color: this.props.gallery[next].text_color })
			};
				
			if (loaded === true) {
		    	settings = {
					dots: 			true,
					arrows: 		true,
					infinite: 		true,
					speed: 			0,
					slidesToScroll: 1,
					centerMode: 	false,
					variableWidth: 	false,
					beforeChange: 	(current, next) => this.setState({ index:next, color: this.props.gallery[next].text_color }),
					autoplay: true,
					autoplaySpeed: 3000,
					pauseOnHover: false,
				};
				this.slider.slickPlay();
			}

			return (				
				
				<div className={'scope-slick scope-slick--' + this.state.color}>
					<Slider ref={slider => (this.slider = slider)} {...settings}>
						{gallery.map((slide,i) =>
							{
								return (
									<div className={'inner ' + slide.fitting} key={i}>							
										<FadeIn>
											{onload => (
												<img
													alt={''} 
													src={slide.src} 
													srcSet={slide.srcset} 
													onLoad={onload}
												/>
											)}
										</FadeIn>
										<p dangerouslySetInnerHTML={{__html:slide.caption}}></p>
									</div>
								)
							}
						)}
						
					</Slider>

				</div>
				
									
			);
			
		} else {
			return null;
		}
	}
}